import React, { memo } from 'react'

interface IAngleIconProps {
  size?: number
}

const AngleIcon: React.FC<IAngleIconProps> = memo(({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M12.1879 0.325322C12.4047 0.542179 12.5132 0.805093 12.5132 1.11406C12.5132 1.42303 12.4047 1.68594 12.1879 1.9028L6.0907 8L12.1879 14.0972C12.4047 14.3141 12.5132 14.577 12.5132 14.8859C12.5132 15.1949 12.4047 15.4578 12.1879 15.6747C11.971 15.8916 11.7081 16 11.3991 16C11.0902 16 10.8272 15.8916 10.6104 15.6747L3.88278 8.94708C3.74267 8.80699 3.64383 8.65921 3.58628 8.50376C3.52869 8.34832 3.4999 8.1804 3.4999 8C3.4999 7.81959 3.52869 7.65167 3.58628 7.49624C3.64383 7.34078 3.74267 7.19301 3.88278 7.05292L10.6104 0.325322C10.8272 0.108439 11.0902 -1.24405e-07 11.3991 -9.73945e-08C11.7081 -7.03835e-08 11.971 0.108439 12.1879 0.325322Z"
      fill="currentColor"
    />
  </svg>
))

export { AngleIcon }
